export const build = { date:"2026-03-05.1321", stage:"alpha" }
